// Module
var code = "<div data-bind=\"css: { open: _isOpenFastFilter }\" class=\"fast-filter fast-filter-text\"> <a class=\"fast-filter-icon\"> <i class=\"fa fa-filter\" data-bind=\"click: OpenFilter, css: {'active-filter-status': _isFilterApplied, [_filterId]: _filterId}\"></i> </a> </div>";
// Exports
export default code;